import { formatMStockNewsRelativeTime } from '@/utils/formatTime'
import clsx from 'clsx'
import { memo, useState } from 'react'

export const NewsArticle = memo(
  ({ title, pressNm, publishedDt, thumbnailLnk, currentTime }) => {
    const [failedThumbnailSrc, setFailedThumbnailSrc] = useState(null)

    const hasThumbnailArea = Boolean(thumbnailLnk)
    const hasThumbnailError = failedThumbnailSrc === thumbnailLnk

    const formattedPublishedDt = formatMStockNewsRelativeTime(publishedDt, currentTime)

    return (
      <article
        className={clsx(
          'border-b-navy-300 border-b py-20',
          hasThumbnailArea ? 'grid grid-cols-[minmax(0,1fr)_72px] gap-8' : 'block'
        )}
      >
        <div className="min-w-0">
          <h4 className="text-16 line-clamp-2 font-bold break-keep">{title}</h4>

          <span className="text-14 text-navy-500 block truncate">
            {pressNm} · <time dateTime={publishedDt}>{formattedPublishedDt}</time>
          </span>
        </div>
        {hasThumbnailArea && (
          <div
            className="bg-navy-100 rounded-12 aspect-square w-full overflow-hidden"
            aria-hidden="true"
          >
            {!hasThumbnailError && (
              <img
                src={thumbnailLnk}
                alt=""
                className="h-full w-full object-cover"
                loading="lazy"
                decoding="async"
                onError={() => setFailedThumbnailSrc(thumbnailLnk)}
              />
            )}
          </div>
        )}
      </article>
    )
  }
)
